export const formatUnit = (unit: string) => (isNaN(Number(unit)) ? unit : `x${unit}`);
